import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Implementation.scss";
import VisitBoard from "./VisitBoard/VisitBoard";
import MonitoringRoundOverview from "./MonitoringRoundOverview/MonitoringRoundOverview";
import MessagePopUp from "../../components/Messages/MessagePopUp";
import TabPane from "antd/es/tabs/TabPane";
import { Tabs } from "antd";

const validPages = {
  "?WaitingForTracking": "WaitingForTracking",
  "?trackingInprogress": "WaitingForTracking",
  "?MonitoringRoundOverview": "MonitoringRoundOverview",
};

function Implementation() {
  const [activeKey, setActiveKey] = useState("WaitingForTracking");
  const location = useLocation();
  const navigate = useNavigate();
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });

  useEffect(() => {
    setActiveKey(validPages[location.search]);
  }, [location]);

  const handleTabChange = (key) => {
    navigate(`/project/implementation?${key}`);
  };

  return (
    <div className="planning-page p-0">
      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />
      <Tabs
        activeKey={activeKey}
        onChange={handleTabChange}
        type="card"
        className="card-tabs"
        destroyInactiveTabPane={true}
      >
        <TabPane tab="Visit Board" key="WaitingForTracking">
          <div className="insideTab m-5">
            <VisitBoard />
          </div>
        </TabPane>
        <TabPane tab="Monitoring Round Overview" key="MonitoringRoundOverview">
          <div className="insideTab m-5">
            <MonitoringRoundOverview />
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default Implementation;
